import React, { Fragment, useState } from "react";
import { Col, FormGroup, Label, Row, Table } from "reactstrap";

const cellStyle = { borderBottom: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' };
const headCellStyle = { borderBottom: '1px solid #e8eaed', borderTop: '1px solid #e8eaed', borderLeft: 'white', borderRight: 'white' };

const permissionRows = [
    { operation: "Read Products from Seller Store", scopes: ["read_products"] },
    { operation: "Read Inventory from Seller Store", scopes: ["read_inventory"] },
    { operation: "Read Orders from Seller Store", scopes: ["read_orders"] },
    { operation: "Create Orders in Seller Store", scopes: ["write_orders"] },
    {
        operation: "Read Fulfilments from Seller Store",
        scopes: ["read_assigned_fulfillment_orders", "read_merchant_managed_fulfillment_orders", "read_fulfillments"],
    },
    {
        operation: "Fulfil Order in Seller Store",
        scopes: ["write_assigned_fulfillment_orders", "write_merchant_managed_fulfillment_orders"],
    },
    {
        operation: "Read Locations and Catalogs to sync Prices and Inventory",
        scopes: ["read_locations", "read_markets", "read_markets_home"],
    },
];

const scopeLineStyle = { lineHeight: "24px", whiteSpace: "nowrap" };

// Topics we subscribe for every seller store (see $requiredWebhooks in SellerRepository).
const webhookTopics = [
    "PRODUCTS_DELETE",
    "PRODUCTS_UPDATE",
    "ORDERS_UPDATED",
    "ORDERS_CANCELLED",
    "FULFILLMENTS_CREATE",
    "FULFILLMENTS_UPDATE",
    "REFUNDS_CREATE",
    "INVENTORY_LEVELS_UPDATE",
    "APP_UNINSTALLED",
];

export const SellerShopifyDetails = (props) => {
    const {
        errors, register, trigger, setValue, getValues,
        shopifyAccessScopes = [],
        shopifyAccessScopesLoading = false,
        shopifyAccessScopesChecked = false,
        shopifyAccessScopesError = "",
        shopifyWebhooks = [],
        shopifyWebhooksLoading = false,
        shopifyWebhooksChecked = false,
    } = props;

    const [showApiKey, setShowApiKey] = useState(false);
    const [showApiSecretKey, setShowApiSecretKey] = useState(false);

    const grantedScopes = Array.isArray(shopifyAccessScopes) ? shopifyAccessScopes : [];

    const connectedWebhooks = Array.isArray(shopifyWebhooks) ? shopifyWebhooks : [];

    const renderWebhookStatus = (topic) => {
        if (shopifyWebhooksLoading) {
            return <span className="text-muted">Checking...</span>;
        }
        if (!shopifyWebhooksChecked) {
            return <span className="text-muted" title="Not checked">-</span>;
        }
        return connectedWebhooks.includes(topic)
            ? <span style={{ color: "#28a745" }}><i className="fa fa-check-circle mr-1" />Connected</span>
            : <span style={{ color: "#dc3545" }}><i className="fa fa-times-circle mr-1" />Not connected</span>;
    };

    const renderScopeStatus = (scope) => {
        if (shopifyAccessScopesLoading) {
            return <span className="text-muted">Checking...</span>;
        }
        if (!shopifyAccessScopesChecked) {
            return <span className="text-muted" title="Not checked">-</span>;
        }
        return grantedScopes.includes(scope)
            ? <i className="fa fa-check-circle" style={{ color: "#28a745" }} title="Granted" />
            : <i className="fa fa-times-circle" style={{ color: "#dc3545" }} title="Missing" />;
    };

    const enableShopifyIntegration = !!getValues("enableShopifyIntegration");
    const shopifyAppType = getValues("shopifyAppType") || "legacy";

    const clearShopifyFields = () => {
        setValue("storeName", "");
        setValue("apiKey", "");
        setValue("apiSecretKey", "");
        setValue("secretKey", "");
    };

    const onToggleEnable = (e) => {
        const checked = e.target.checked;
        setValue("enableShopifyIntegration", checked);

        // optional: keep shopifyAppType as-is or set default
        /*if (!checked) {
            setValue("shopifyAppType", "legacy");
            clearShopifyFields();
        }*/

        trigger([
        "enableShopifyIntegration",
        "shopifyAppType",
        "storeName",
        "apiKey",
        "apiSecretKey",
        "secretKey",
        ]);
    };

    const onChangeAppType = (e) => {
        const val = e.target.value;
        setValue("shopifyAppType", val);
        trigger(["shopifyAppType", "storeName", "apiKey", "apiSecretKey", "secretKey"]);
    };
    
    return (
        <Fragment>
            <Row>
                {!!shopifyAccessScopesError && (
                    <Col md={12}>
                        <div className="alert alert-danger" role="alert" style={{ marginBottom: 24 }}>
                            <strong>While connecting to the seller store, we are getting this error below</strong>
                            <div className="mt-1">{shopifyAccessScopesError}</div>
                        </div>
                    </Col>
                )}
                <Col md={12}>
                    <FormGroup>
                        <div className="form-check">
                        <input
                            id="enableShopifyIntegration"
                            type="checkbox"
                            className="form-check-input"
                            {...register("enableShopifyIntegration")}
                            checked={enableShopifyIntegration}
                            onChange={onToggleEnable}
                        />
                        <Label className="form-check-label" for="enableShopifyIntegration">
                            Enable Shopify Integration
                        </Label>
                        </div>
                    </FormGroup>
                    </Col>

                    {enableShopifyIntegration && (
                    <>
                        <Col md={12}>
                        <FormGroup>
                            <Label className="form-label">
                            App Type <span style={{ color: "red" }}>*</span>
                            </Label>

                            <div className="d-flex" style={{ gap: 20 }}>
                            <div className="form-check">
                                <input
                                id="shopifyAppType-legacy"
                                type="radio"
                                name="shopifyAppType"
                                value="legacy"
                                className="form-check-input"
                                {...register("shopifyAppType")}
                                checked={shopifyAppType === "legacy"}
                                onChange={onChangeAppType}
                                />
                                <Label className="form-check-label" for="shopifyAppType-legacy">
                                Shopify Legacy App
                                </Label>
                            </div>

                            <div className="form-check">
                                <input
                                id="shopifyAppType-new"
                                type="radio"
                                name="shopifyAppType"
                                value="new"
                                className="form-check-input"
                                {...register("shopifyAppType")}
                                checked={shopifyAppType === "new"}
                                onChange={onChangeAppType}
                                />
                                <Label className="form-check-label" for="shopifyAppType-new">
                                Shopify New App
                                </Label>
                            </div>
                            </div>

                            <div className="text-danger" style={{ fontSize: 12 }}>
                            {errors.shopifyAppType?.message}
                            </div>
                        </FormGroup>
                        </Col>

                        <Col md={12}>
                        <FormGroup>
                            <Label className="form-label">
                            Store Name <span style={{ color: "red" }}>*</span>
                            </Label>
                            <input
                            name="storeName"
                            type="text"
                            className={`form-control ${errors.storeName ? "is-invalid" : ""}`}
                            placeholder="example.myshopify.com"
                            {...register("storeName")}
                            />
                            <div className="invalid-feedback">{errors.storeName?.message}</div>
                        </FormGroup>
                        </Col>

                        <Col md={6}>
                        <FormGroup>
                            <Label className="form-label">
                            {shopifyAppType === "new" ? "Client ID" : "API Key"}{" "}
                            <span style={{ color: "red" }}>*</span>
                            </Label>
                            <div style={{ position: "relative" }}>
                                <input
                                name="apiKey"
                                type={showApiKey ? "text" : "password"}
                                style={{ paddingRight: 38 }}
                                className={`form-control ${errors.apiKey ? "is-invalid" : ""}`}
                                {...register("apiKey")}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowApiKey(!showApiKey)}
                                    title={showApiKey ? "Hide" : "Show"}
                                    style={{ position: "absolute", top: 0, right: 0, height: "100%", width: 38, border: "none", background: "transparent", cursor: "pointer", color: "#7b7b7b" }}
                                >
                                    <i className={showApiKey ? "fa fa-eye-slash" : "fa fa-eye"} />
                                </button>
                                <div className="invalid-feedback">{errors.apiKey?.message}</div>
                            </div>
                        </FormGroup>
                        </Col>

                        <Col md={6}>
                        <FormGroup>
                            <Label className="form-label">
                            {shopifyAppType === "new" ? "Secret" : "API Secret Key"}{" "}
                            <span style={{ color: "red" }}>*</span>
                            </Label>
                            <div style={{ position: "relative" }}>
                                <input
                                name="apiSecretKey"
                                type={showApiSecretKey ? "text" : "password"}
                                style={{ paddingRight: 38 }}
                                className={`form-control ${errors.apiSecretKey ? "is-invalid" : ""}`}
                                {...register("apiSecretKey")}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowApiSecretKey(!showApiSecretKey)}
                                    title={showApiSecretKey ? "Hide" : "Show"}
                                    style={{ position: "absolute", top: 0, right: 0, height: "100%", width: 38, border: "none", background: "transparent", cursor: "pointer", color: "#7b7b7b" }}
                                >
                                    <i className={showApiSecretKey ? "fa fa-eye-slash" : "fa fa-eye"} />
                                </button>
                                <div className="invalid-feedback">{errors.apiSecretKey?.message}</div>
                            </div>
                        </FormGroup>
                        </Col>

                        {shopifyAppType === "legacy" && (
                        <Col md={12}>
                            <FormGroup>
                            <Label className="form-label">
                                Access Token <span style={{ color: "red" }}>*</span>
                            </Label>
                            <input
                                name="secretKey"
                                type="text"
                                className={`form-control ${errors.secretKey ? "is-invalid" : ""}`}
                                {...register("secretKey")}
                            />
                            <div className="invalid-feedback">{errors.secretKey?.message}</div>
                            </FormGroup>
                        </Col>
                        )}

                        <Col md={12} className="mt-3">
                            <h4 style={{marginBottom: 50}}>Permission required while creating custom app at Shopify Admin</h4>
                            <span style={{fontWeight: "bold"}}>Below permissions are required to integrate your store with our system. Please make sure all permission are assigned. Any missing permission may result in unexpected behavior or errors</span>

                            <Table bordered style={{marginTop:50}}>
                                <thead>
                                <tr>
                                    <th style={headCellStyle}>Operation</th>
                                    <th style={headCellStyle}>Permissions</th>
                                    <th style={headCellStyle}>Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                {permissionRows.map((row) => (
                                    <tr key={row.operation}>
                                        <td style={cellStyle}>{row.operation}</td>
                                        <td style={cellStyle}>
                                            {row.scopes.map((scope) => (
                                                <div key={scope} style={scopeLineStyle}>{scope}</div>
                                            ))}
                                        </td>
                                        <td style={cellStyle}>
                                            {row.scopes.map((scope) => (
                                                <div key={scope} style={scopeLineStyle}>{renderScopeStatus(scope)}</div>
                                            ))}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </Col>
                        
                        <Col md={12} className="mt-3">
                            <h4 style={{marginBottom: 20}}>Webhooks</h4>
                            <span style={{fontWeight: "bold"}}>Below webhooks are subscribed on the seller Shopify store so we receive product, order, fulfilment, refund and inventory updates.</span>

                            <Table bordered style={{marginTop:30}}>
                                <thead>
                                <tr>
                                    <th style={headCellStyle}>Webhook Topic</th>
                                    <th style={headCellStyle}>Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                {webhookTopics.map((topic) => (
                                    <tr key={topic}>
                                        <td style={cellStyle}>{topic}</td>
                                        <td style={cellStyle}>{renderWebhookStatus(topic)}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </Col>

                        <Col md={12} className="mt-4">
                            <a
                                href="https://storage.googleapis.com/qa_goddiva_market_place/upload/Shopify_Custom_App_Guide_Goddiva.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                                className="btn btn-info btn-sm"
                                style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}
                            >
                                <i className="icofont icofont-download"></i>
                                Download Shopify Custom App Guide
                            </a>
                        </Col>
                    </>
                )}
            </Row>
        </Fragment>
    )
}